import * as React from 'react'

const SvgBookIcon = (props) => (
  <svg
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 2.16819V10.8349M7.5 2.16819C6.7214 1.65092 5.66433 1.33301 4.5 1.33301C3.33567 1.33301 2.2786 1.65092 1.5 2.16819V10.8349C2.2786 10.3176 3.33567 9.99967 4.5 9.99967C5.66433 9.99967 6.7214 10.3176 7.5 10.8349M7.5 2.16819C8.2786 1.65092 9.33567 1.33301 10.5 1.33301C11.6643 1.33301 12.7214 1.65092 13.5 2.16819V10.8349C12.7214 10.3176 11.6643 9.99967 10.5 9.99967C9.33567 9.99967 8.2786 10.3176 7.5 10.8349"
      stroke="#FFAF5F"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgBookIcon
